import { inject } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { DateTime } from 'luxon';
import { map, Observable, of } from 'rxjs';
import { GetAllBoardMetadataAndPersonalBoardResponse } from '../../../../../backend/src/core/board/board.gate';
import { environment } from '../../../environments/environment';
import { CoreItemType } from '../../core/core-item/core-item';
import { InitAllBoardListService } from '../../core/init-data/init-all-board-list.service';
import { StripeProductStatus, StripeProductType } from '../../core/stripe/product.stripe';
import { StripeService } from '../../core/stripe/stripe.service';
import { StripeSubscriptionStatus } from '../../core/stripe/subscription.stripe';
import { UserClerkService } from '../../core/user/user-clerk.service';
import { WebSocketService } from '../../core/websocket/websocket.service';
import { WorkspaceHolderService } from '../../core/workspace/workspace.holder.service';
import { Id } from '../../shared/id/id';
export const authResolver = (route: ActivatedRouteSnapshot): Observable<any> => {
  const webSocketService = inject(WebSocketService);
  const userClerkService = inject(UserClerkService);
  const initAllBoardListService = inject(InitAllBoardListService);
  const workspaceHolderService = inject(WorkspaceHolderService);
  const stripeService = inject(StripeService);

  webSocketService.connect();

  const id = route.paramMap.get('id');

  let workspaceId: string | undefined = undefined;
  if (Id.backend.chop(id)?.coreType === CoreItemType.workspace) {
    workspaceId = id === null ? undefined : id;
  }

  const user = userClerkService.getUser();

  if (!user) {
    return of(false);
  }

  return initAllBoardListService.getAllBoardMetadataAndPersonalBoardAndChangeDefaultWorkspace$(workspaceId).pipe(
    map((response: GetAllBoardMetadataAndPersonalBoardResponse) => {
      const currentWorkspace = workspaceHolderService.currentWorkspace();

      let productId = '';

      stripeService.setSubscription(response.subscription);

      const subscription = stripeService.getSubscription();

      subscription?.items.data.forEach((item) => {
        productId = item.plan.product;
      });

      const product = environment.stripe.productList.find((product) => product.id === productId);

      if (product) {
        // subscription?.current_period_start;
        // subscription?.current_period_end;

        if (
          subscription?.status === StripeSubscriptionStatus.active ||
          subscription?.status === StripeSubscriptionStatus.trialing
        ) {
          workspaceHolderService.paidStatus.set({
            status: StripeProductStatus.paid,
            type: product?.type ?? StripeProductType.basic,
            startTime: DateTime.fromSeconds(subscription?.current_period_start ?? 0),
            endTime: DateTime.fromSeconds(subscription?.current_period_end ?? 0),
          });
        } else {
          workspaceHolderService.paidStatus.set({
            status: StripeProductStatus.expired,
            type: product?.type ?? StripeProductType.basic,
            startTime: DateTime.fromSeconds(subscription?.current_period_start ?? 0),
            endTime: DateTime.fromSeconds(subscription?.current_period_end ?? 0),
          });
        }
      } else {
        if (currentWorkspace.publicSubData?.trialExpiredTimeStr) {
          const startTimeStr = currentWorkspace.publicSubData.trialStartTimeStr;
          const trialExpiredTime = DateTime.fromISO(currentWorkspace.publicSubData.trialExpiredTimeStr);
          const now = DateTime.local();

          if (trialExpiredTime < now) {
            workspaceHolderService.paidStatus.set({
              status: StripeProductStatus.expired,
              type: currentWorkspace.publicSubData?.trialType ?? StripeProductType.basic,
              startTime: startTimeStr ? DateTime.fromISO(startTimeStr) : undefined,
              endTime: trialExpiredTime,
            });
          } else {
            workspaceHolderService.paidStatus.set({
              status: StripeProductStatus.trial,
              type: currentWorkspace.publicSubData?.trialType ?? StripeProductType.basic,
              startTime: startTimeStr ? DateTime.fromISO(startTimeStr) : undefined,
              endTime: trialExpiredTime,
            });
          }
        }
      }
    })
  );
};
